import { useEffect, useState } from 'react';
import { CardBoxContainer, CardGrid } from './styled';
import TopicCard from './TopicCard';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';

export default function TopicListingCard(props) {
  const { cardData, title } = props;
  const [gridCardSignal, setGridCardSignal] = useState({
    index: '',
    show: false,
  });
  useEffect(() => {
    if (cardData) {
      let cardIds = '';
      cardData?.map((element, index) => {
        let id = element?.term_id;
        index == 0 ? (cardIds = id) : (cardIds = cardIds + ',' + id);
      });
      fireServedSectionEvent(title, cardIds, 'Topics List');
    }
  }, []);
  return (
    <>
      <CardGrid>
        {cardData?.map((data, index) => {
          return (
            <CardBoxContainer key={`topic_${index}`}>
              <TopicCard
                gridCardSignal={gridCardSignal}
                setGridCardSignal={setGridCardSignal}
                itemIndex={index}
                title={title}
                data={data}
              />
            </CardBoxContainer>
          );
        })}
      </CardGrid>
    </>
  );
}
